import { types, type Instance } from 'mobx-state-tree';
import EDG from './edg';
import OET from './oet';
import FSMView from './fsm';
import type { IFSM } from '../metamodel/fsm';

/**
 * A MERODE ui model
 */
const UIModel = types
  .model('UIModel', {
    // the edg, see './edg.js'
    edg: types.optional(EDG, () => EDG.create({})),
    // the oet, see './oet.js'
    oet: types.optional(OET, () => OET.create({})),
    // the fsms, see './fsms.js'
    fsms: types.optional(types.array(FSMView), []),
  })
  .views(self => ({
    findFSM(fsm: IFSM) {
      return self.fsms.find(f => f.fsm === (fsm as unknown as typeof f.fsm));
    },
    findFSMById(id: string) {
      // Guard dangling views: `modelReference` resolves a dead fsm id to
      // `undefined` (refHelper.js), so an orphaned FSMView (left behind by an
      // out-of-band FSM deletion) would make `f.fsm.id` throw — which rejected
      // EditFSMController.deleteFSM and wedged the app in a busy-modal.
      return self.fsms.find(f => f.fsm != null && f.fsm.id === id);
    },
  }))
  .actions(self => ({
    addFSM(fsm: string) {
      const fsmview = FSMView.create({
        fsm,
      });
      self.fsms.push(fsmview);
      return fsmview;
    },
    removeFSM(fsm: string) {
      const fsmview = self.findFSMById(fsm);
      self.fsms.remove(fsmview as unknown as (typeof self.fsms)[number]);
    },
  }));

export type IUIModel = Instance<typeof UIModel>;

export default UIModel;
